import { message, Select } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { useSession } from "../utils/Session";
import { apiCall } from "../utils/Api";
import Cookies from 'js-cookie';

export default function PermissionSelector(props) {
    const [session, setSession] = useSession();
    const [loading, setLoading] = useState(false);
    const [selectedCorp, setSelectedCorp] = useState(session.user.corp_id);
    const [availableCorps, setAvailableCorps] = useState([]);

    const onGetAvailableCorps = (_status, _result) => {
        if (_status) {
            setAvailableCorps(_result);
        }
    };

    useEffect(() => {
        apiCall("account/getAvailableCorps", {}, onGetAvailableCorps);
    }, []);

    const onTransfer = (_status, _result) => {
        if (_status) {
            if (_result["STG"]) {
                Cookies.set("STG", _result["STG"], { expires: 365 });
            }
            Cookies.set("want_v1", 1, { expires: 365 });
            setLoading(false);
            window.location.reload();
        }
    };

    const onSetCorp = (_status, _result) => {
        if (_status) {
            if (_result.is_personal || _result.is_institution) {
                setLoading(false);
                apiCall("session/get", {}, (_status, _result) => {
                    if (_status) {
                        setSession(_result);
                        window.location.reload();
                    }
                });
            } else {
                apiCall("v1/transfer", {}, onTransfer);
            }
        }
    };

    const setCorp = (_corp) => {
        apiCall("account/setCorp", { corp_id: _corp }, (_s, _r) => {
            if (_s) {
                window.location.reload();
            } else {
                message.error(_r.error);
            }
        });
    };

    const changeCorp = (_corpId) => {
        const corp = availableCorps.find(c => c.id === _corpId);
        if (corp?.url) {
            window.open(corp.url, "_blank");
        } else {
            setLoading(true);
            setSelectedCorp(_corpId);
            setCorp(_corpId);
        }
    };

    const drawOptions = () => {
        return availableCorps.map((item, index) => {
            let label = item.name;
            if (item.is_institution && item.company) {
                label = item.company;
            }

            return (
                <Select.Option key={item.id} value={item.id}>
                    <span style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <span>{label}</span>
                        {item.url && <LinkOutlined style={{ marginLeft: 8 }} />}
                    </span>
                </Select.Option>
            );
        });
    };

    return (
        <>
            {availableCorps.length > 1 && (
                <>
                    <Select
                        className="asa-select"
                        loading={loading}
                        onChange={changeCorp}
                        style={{ width: '100%' }}
                        value={selectedCorp}
                        dropdownMatchSelectWidth={false}
                    >
                        {drawOptions()}
                    </Select>
                    <br clear="all" />
                    <div className="shim"></div>
                    <div className="shim"></div>
                </>
            )}
        </>
    );
}
